import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './shared/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/api/') && !req.url.includes('boxcloud')) {
      const token = this.authService.impersonatedToken || this.authService.token;

      return next
        .handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          }),
        )
        .pipe(
          tap(
            e => {},
            err => {
              if (err?.status === 401) {
                console.log('Not authorized');
                this.authService.logout();
                // window.location.href = '/login';
              }
            },
          ),
        );
    } else {
      return next.handle(req);
    }
  }
}
